import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

interface BulkDuplicateResult {
  ok: boolean
  failedIds: string[]
}

export function useDuplicateConfigurationsBulkMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (ids: string[]): Promise<BulkDuplicateResult> => {
      if (ids.length === 0) return { ok: false, failedIds: [] }

      const uniqueIds = [...new Set(ids)]
      const res = await fetchApi<{
        duplicatedIds?: string[]
        failed?: { id: string; error?: string }[]
      }>({
        endpoint: '/api/configurations/bulk-duplicate',
        method: 'POST',
        body: { ids: uniqueIds },
      })

      const failedIds = (res.failed ?? []).map((f) => f.id)
      return failedIds.length > 0 ? { ok: false, failedIds } : { ok: true, failedIds: [] }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['configurations', 'list'] })
    },
  })
}
